import React, {Component} from 'react'
import { Row, Col, FormControl, Modal, Form, FormGroup, Button } from 'react-bootstrap'
import { Checkbox, Radio } from 'react-icheck'
import PrintPreview from '../PrintPreview'
import FontAwsome from 'react-fontawesome'
import WorkdocStore from '../../../stores/WorkdocStore'
import PdfStore from '../../../stores/PdfStore'
import TextFieldModal from '../../../component/element/TextFieldModal'
import miles from '../../../asset/img/miles.jpg';
import fuelgaugeSrc from '../../../asset/img/fuelgauge3-150.png';

var NotificationSystem = require('react-notification-system');
const RELATED_DETAIL = {
  fuel_gauge: {fuel: {x: '',y: ''}},
  doc: {other: '', docList: [{title:'ใบเคลม', status: false}, {title: 'ใบขับขี่', status: false}, {title: 'บัตรประชาชน', status: false}, {title: 'ทะเบียนรถ', status: false}, {title: 'อื่นๆ', status: false}]},
  miles: '',
  asset: {other: '', assetList: [{title: 'ล้ออะไหล่', status: false}, {title: 'เครื่องมือ/แม่แรง', status: false}, {title: 'ผ้ายางปูพื้น', status: false}, {title: 'กุญแจ', status: false}]},
  damage: ''
}
const DEFAULT_ROW = 21
class PrintBHLParkingCarDoc extends Component {

  constructor(...args){
    super(...args)

    this.canvasFuelgauge = new Array(1).fill('')
    this.state = {loading:false,data:[],related_detail:RELATED_DETAIL,page_title:'กำลังดึงข้อมูล..',dataList:[]}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadAnyParkingcarDoc()
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {added_by:'',added_date:'',bf_work_damage_id:'',detail:'',discount_amount:'',discount_percent:'',export_stock_flag:'',fix_flag:'',genpart_itemnum:'',item_seq:'',itemnum:'',paint_flag:'',part_by:'',part_cost:'',part_flag:'',part_from:'',part_type:'',po_state:'',prefer_repair:'',price_on_shop:'',price_per_unit:'',quantity:'',remark:'',row_style:'',seq:'',stock_flag:'',wage_cost:'',wage_itemnum:'',wait_insurer_flag:'',work_no:''}
    })
  }

  loadAnyParkingcarDoc() {
    let {workNo} = this.props
    let {data,related_detail,dataList} = this.state
    PdfStore.loadAnyParkingcarDoc(workNo,'bhl_parking_doc',(result)=>{
      if (result.data.related_detail===undefined||result.data.related_detail.doc===undefined||result.data.related_detail.asset
===undefined) {
        related_detail = RELATED_DETAIL
      } else {
        related_detail = result.data.related_detail
      }
      dataList = this.getPagination(result.data.fixinglist)
      this.canvasFuelgauge = new Array(dataList.length).fill('')
      this.setState({data:result.data,page_title:'ไม่พบข้อมูล',related_detail:related_detail,dataList:dataList})  
      let that = this
      dataList.forEach(function(item,index) {    
        that.setFuelgauge(related_detail.fuel_gauge,index)
      })
    }) 
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} />)
    else
      return ('')
  }

  onOtherClick(key,value,e) {
    let fieldInfo = {title:key=='doc'?'อื่นๆ':key=='asset'?'จำนวนกุญแจ':key=='miles'?'เลขที่ไมล์ที่':'ความเสียหายนอกเหนือรายการซ่อม',showClear:false,value:value,key:key}
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  onOtherSave(fieldInfo) {
    let {related_detail} = this.state
    let note = fieldInfo.value === undefined ? '' : fieldInfo.value
    
    if (fieldInfo.key==='damage'||fieldInfo.key==='miles')
      related_detail[fieldInfo.key] = note
    else
      related_detail[fieldInfo.key].other = note
    
    this.setState({related_detail:related_detail})
    this.saveBHLParkingCarDoc()
  }

  saveBHLParkingCarDoc() {
    let {workNo} = this.props
    let {related_detail} = this.state
    
    WorkdocStore.saveWorkdocRelated(workNo,'bhl_parking_doc',related_detail,(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderSignature() {
    let {data} = this.state
    return(
        <div className='footer-page'>
          <table className='table table-print-wcs-parking-car-doc'>
            <tbody>
              <tr>
                <td style={{width:'50%'}}>ผู้รับรถ (พนักงานอู่).............................................................</td>
                <td style={{width:'50%'}}>ผู้นำรถเข้า (ลูกค้า).............................................................</td>
              </tr>
              <tr>
                <td>วันรับรถเข้า {data.receiving!==undefined?data.receiving.contact_date:'........................................................................'}</td>
                <td>วันนัดรถออก {data.receiving!==undefined?data.receiving.appointment_date:'....................................................................'}</td>
              </tr>
            </tbody>
          </table>
          <div className='text-center'>** โปรดเก็บทรัพย์สินมีค่าของท่านออกจากรถ มิฉะนั้นทางอู่จะไม่รับผิดชอบใดๆทั้งสิ้น **</div>
        </div>  
    )
  }

  renderBody(item,index) {
    let {data} = this.state
    return(
      <div>
        <table className='table table-print-wcs-parking-car-doc'>
          <tbody>
            <tr>
              <td style={{width:'50%'}}>ทะเบียน {data.car!==undefined?data.car.car_registration_no:''}</td>
              <td style={{width:'50%'}}>ยี่ห้อ/รุ่น {data.car!==undefined?data.car.brand:''} {data.car!==undefined?data.car.model:''}</td>
            </tr>
            <tr>
              <td>ประกัน {data.insurer!==undefined?data.insurer.insurance_type:''}</td>
              <td>สีรถตัวรถ {data.car!==undefined?data.car.car_color:''}</td>
            </tr>
            <tr>
              <td colSpan={2}>เจ้าของรถ {data.owner!==undefined?data.owner.title:''}{data.owner!==undefined?data.owner.name:''}</td>
            </tr>
            <tr>
              <td colSpan={2}>เบอร์โทรติดต่อ {data.owner!==undefined?data.owner.tel:''}</td>
            </tr>
            <tr>
              <td colSpan={2}>บริษัทประกัน {data.insurer!==undefined?data.insurer.insurer_name:''}</td>
            </tr>
          </tbody>
        </table>
        {this.renderDoc(item,index)}
        {this.renderSignature()}
      </div>
    )
  }

  renderRepairListRowData(items,indexs) {
    indexs = parseFloat(indexs)+1
    indexs = indexs*20 - 20

    if (items.length===0)
      items = this.newEmptyRow(20)
    else
      items = items.concat(this.newEmptyRow(20-items.length))

    return(
      items.map((item,index) => {
        return(
          <tr key={index}>
            <td className='text-center'>{item.bf_work_damage_id===''?<br/>:index+1+indexs}</td>
            <td colSpan={4}>{item.detail}</td>
          </tr>
        )
      })
    )
  }

  onDrawLine(index,e) {
    let {data,related_detail,dataList} = this.state
    const context = this.canvasFuelgauge[index].getContext('2d')
    var r = this.canvasFuelgauge[index].getBoundingClientRect();
    var x = e.clientX - r.left;
    var y = e.clientY - r.top;


    related_detail.fuel_gauge.fuel['x'] = x
    related_detail.fuel_gauge.fuel['y'] = y

    this.setState({related_detail:related_detail})
    let that = this
    dataList.forEach(function(item,_index) {
      that.setFuelgauge(related_detail.fuel_gauge,_index)
    })  
    this.saveBHLParkingCarDoc()
  }

  setFuelgauge(fuel_gauge,index=0) {
    const contextFuelgauge = this.canvasFuelgauge[index].getContext('2d')
    const imageFuelgauge = new Image()
    imageFuelgauge.src = fuelgaugeSrc
    imageFuelgauge.onload = () => {
      contextFuelgauge.drawImage(imageFuelgauge, 0, 0, this.canvasFuelgauge[index].width, this.canvasFuelgauge[index].height)
      this.setDrawLine(fuel_gauge,index)
    }
  }

  setDrawLine(fuel_gauge,index) {
    const context = this.canvasFuelgauge[index].getContext('2d')
    const imageFuelgauge = new Image()
    imageFuelgauge.src = fuelgaugeSrc
    context.drawImage(imageFuelgauge, 0, 0, 100, 50);

    var r = this.canvasFuelgauge[index].getBoundingClientRect();
    var x = fuel_gauge.fuel['x']
    var y = fuel_gauge.fuel['y']
    if (x!=""&&y!="") {
      context.beginPath();
      context.moveTo(x, y);
      context.lineTo(50, 50);
      context.lineWidth = 5;

      context.strokeStyle = '#ff0000';
      context.stroke();
    }     
  }

  renderFuelgauge(index) {
    let {related_detail} = this.state
    return(
      <div>                
        <canvas
          onClick={this.onDrawLine.bind(this,index)}
          ref={(canvasFuelgauge) => {this.canvasFuelgauge[index] = canvasFuelgauge}}
          width="100" height="50">
          <p>Error</p>
        </canvas>
      </div>
    )
  }

  onCheckDocChange(key,value,e) {
    let {related_detail} = this.state
    if (value)
      related_detail.doc.docList[key].status = false
    else 
      related_detail.doc.docList[key].status = true

    this.setState({related_detail:related_detail})
    this.saveBHLParkingCarDoc()
  }

  onCheckAssetChange(key,value,e) {
    let {related_detail} = this.state
    if (value)
      related_detail.asset.assetList[key].status = false
    else 
      related_detail.asset.assetList[key].status = true

    this.setState({related_detail:related_detail})
    this.saveBHLParkingCarDoc()
  }

  renderColDoc() {
    let {related_detail} = this.state
    return(
      related_detail.doc.docList.map((item,index) => {
        return(
            <td key={index} style={{width:'20%'}} className={index!==related_detail.doc.docList.length-1?'bt-h br-h':'bt-h'}>
              <Checkbox
                onChange={this.onCheckDocChange.bind(this,index,item.status)}
                checked={item.status}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ' + item.title}
              >
              </Checkbox>
              <span onClick={this.onOtherClick.bind(this,'doc',related_detail.doc.other)} style={{cursor:'pointer',display:index===related_detail.doc.docList.length-1?'':'none'}}>{related_detail.doc.other===''?' .....':' '+related_detail.doc.other}</span>
            </td>
        )
      })
    )
  }

  renderColAsset() {
    let {related_detail} = this.state
    return(
      related_detail.asset.assetList.map((item,index) => {
        return(
            <td colSpan={index===related_detail.asset.assetList.length-1?2:1} key={index} style={{width:'20%'}} className={index!==related_detail.asset.assetList.length-1?'bt-h br-h':'bt-h'}>
              <Checkbox
                onChange={this.onCheckAssetChange.bind(this,index,item.status)}
                checked={item.status}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ' + item.title}
              >
              </Checkbox>
              <span onClick={this.onOtherClick.bind(this,'asset',related_detail.asset.other)} style={{cursor:'pointer',display:index===related_detail.asset.assetList.length-1?'':'none'}}>{related_detail.asset.other===''?' ..... ดอก':' ' + related_detail.asset.other + ' ดอก'}</span>
            </td>
        )
      })
    )
  }

  renderDoc(item,index) {
    let {related_detail} = this.state
    return(
        <table className='table table-print-wcs-parking-car-check'>
          <tbody>
            <tr>
              <td colSpan={5}>เอกสารที่รับจากลูกค้า</td>
            </tr>
            <tr>
              {this.renderColDoc()}
            </tr>
            <tr>
              <td className='br-h'>สภาพรถและอุปกรณ์<br/>ระดับน้ำมันเชื้อเพลิง</td>
              <td className='br-h'>{this.renderFuelgauge(index)}</td>
              <td colSpan={3}>เลขที่ไมล์ที่ <span style={{cursor:'pointer'}} onClick={this.onOtherClick.bind(this,'miles',related_detail.miles)}>{related_detail.miles===''?'.....':related_detail.miles}</span></td>
            </tr>
            <tr>
              {this.renderColAsset()}
            </tr>
            <tr>
              <td colSpan={5}>ความเสียหายนอกเหนือรายการซ่อม (แผลเก่า) <span style={{cursor:'pointer'}} onClick={this.onOtherClick.bind(this,'damage',related_detail.damage)}>{related_detail.damage===''?'.....':related_detail.damage}</span></td>
            </tr>
            <tr>
              <td className='text-center'>ลำดับที่</td>
              <td className='text-center' colSpan={4}>รายการซ่อมรถ</td>
            </tr>
            {this.renderRepairListRowData(item,index)}
          </tbody>
        </table>  
    )
  } 

  renderComponentPage(item,index) {
    let {data} = this.state
    return(
      <div className='bhl-parking-car-doc font-print' key={index}>
        <header>
          <h2 className="text-right">{this.props.title}</h2>
        </header>  
        <article className={"article-company "+data.logo_class}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-18" style={{paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>           
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>เลขประจำตัวผู้เสียภาษีอากร {data.company_tax} โทร {data.company_tel}</p>              
            </strong>
          </section>
        </article>
        {this.renderBody(item,index)}
      </div>  
    )
  }

  getPagination(data) {
    let newData = []
    let allData = []
    let checkRow = 0

    if (data.length===0) {
      allData.push(this.newEmptyRow(20))
    } else {
      data.forEach(function(item,index) {
        if (checkRow<DEFAULT_ROW)
          checkRow++
          newData.push(item)

        if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
          allData.push(newData)
          checkRow = 0
          newData = []
        }
      })
    }  
    
    return allData
  }

  render() {
    let {loading,dataList} = this.state
    return(
      <div>
        <PrintPreview 
            loading={loading}
            leftBarTitle={this.props.title}
          >
            {
              dataList.map((item,index) => {
                return this.renderComponentPage(item,index)
              })  
            }
        </PrintPreview>
        <TextFieldModal 
          ref='textFieldModal'
          confirmTitle='บันทึก'
          onConfirm={this.onOtherSave.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintBHLParkingCarDoc.defaultProps = {
  title: 'ใบรับรถเข้าซ่อม',  
  mode : '1'
}
export default PrintBHLParkingCarDoc;


// WEBPACK FOOTER //
// ./src/view/print/bhl/PrintBHLParkingCarDoc.js